import RecipientsList from "./RecipientsList";
export default RecipientsList;
